"use strict";

globalThis.Hologram.pendingScripts ??= [];

globalThis.Hologram.pendingScripts.push({
  digest: new URL(document.currentScript.src).pathname.match(/-([^-]+)\.js$/)[1],
  define: (deps) => {
    const {
      Bitstring,
      ERTS,
      HologramBoxedError,
      HologramInterpreterError,
      Interpreter,
      MemoryStorage,
      Type,
      Utils,
    } = deps;

Interpreter.defineElixirFunction("Calendar.ISO", "naive_datetime_to_iodata", 8, "public", [{params: (context) => [Type.variablePattern("year_0"), Type.variablePattern("month_1"), Type.variablePattern("day_2"), Type.variablePattern("hour_3"), Type.variablePattern("minute_4"), Type.variablePattern("second_5"), Type.variablePattern("microsecond_6"), Type.variablePattern("format_7")], guards: [], body: (context) => {
return Interpreter.consOperator(Elixir_Calendar_ISO["date_to_iodata/4"](context.vars.year_0, context.vars.month_1, context.vars.day_2, context.vars.format_7), Interpreter.consOperator(Type.integer(32n), Elixir_Calendar_ISO["time_to_iodata/5"](context.vars.hour_3, context.vars.minute_4, context.vars.second_5, context.vars.microsecond_6, context.vars.format_7)));
}}]);

Interpreter.defineElixirFunction("Calendar.ISO", "naive_datetime_to_string", 7, "public", [{params: (context) => [Type.variablePattern("x0_0"), Type.variablePattern("x1_1"), Type.variablePattern("x2_2"), Type.variablePattern("x3_3"), Type.variablePattern("x4_4"), Type.variablePattern("x5_5"), Type.variablePattern("x6_6")], guards: [], body: (context) => {
return Elixir_Calendar_ISO["naive_datetime_to_string/8"](context.vars.x0_0, context.vars.x1_1, context.vars.x2_2, context.vars.x3_3, context.vars.x4_4, context.vars.x5_5, context.vars.x6_6, Type.atom("extended"));
}}]);

Interpreter.defineElixirFunction("Calendar.ISO", "naive_datetime_to_string", 8, "public", [{params: (context) => [Type.variablePattern("year_0"), Type.variablePattern("month_1"), Type.variablePattern("day_2"), Type.variablePattern("hour_3"), Type.variablePattern("minute_4"), Type.variablePattern("second_5"), Type.variablePattern("microsecond_6"), Type.variablePattern("format_7")], guards: [], body: (context) => {
return Erlang["iolist_to_binary/1"](Elixir_Calendar_ISO["naive_datetime_to_iodata/8"](context.vars.year_0, context.vars.month_1, context.vars.day_2, context.vars.hour_3, context.vars.minute_4, context.vars.second_5, context.vars.microsecond_6, context.vars.format_7));
}}]);
  },
});

document.dispatchEvent(new CustomEvent("hologram:scriptLoaded"));